
<div>
  <div class="min-w-0 flex-1">
    <h3 class="text-lg font-medium leading-6 text-gray-900"
        *ngIf="!hasCustomTitle; else customTitle">DASHBOARD</h3>

    <ng-template #customTitle >
      <h3 class="text-lg font-medium leading-6 text-gray-900">{{ title }}</h3>
    </ng-template>

  </div>
</div>
